import { Stack, StackProps } from '@mui/material'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { FC, ReactNode } from 'react'

interface LoginCardProps extends StackProps {
    children: ReactNode
}

export const LoginCard: FC<LoginCardProps> = ({ children, ...props }) => <Stack
    spacing={4}
    sx={{
        borderRadius: C1BorderRadius.extraLarge,
        backgroundColor: 'background.default',
        p: 5,
        maxWidth: '500px',
        boxShadow: 2,
        '@media (max-width: 400px)': {
            padding: 4,
            mx: 1,
        },
        ...props.sx,
    }}
    {...props}
>
    {children}
</Stack>
